import { useState } from 'react'
import globalStyle from '../../styles/common.module.css'
import style from './story.module.css'

// ~~~~~~~~~~~~~~~~~~~~ TOGGLE ~~~~~~~~~~~~~~~~~~~~
export function Toggle({
  option1,
  option2,
  changeHandler,
}: {
  option1: string
  option2: string
  changeHandler: (state: string) => void
}) {
  const [state, setState] = useState(option1)

  return (
    <div
      className={[style.toggle, state === option1 ? '' : style.toggleActive].join(' ')}
      onClick={() => {
        changeHandler(state === option1 ? option2 : option1)
        setState(state === option1 ? option2 : option1)
      }}
    >
      <div className={[style.toggleSlider].join(' ')}></div>
    </div>
  )
}



